/**
 * Sentry stub — Kindra frontend.
 *
 * Activated automatically when REACT_APP_SENTRY_DSN is set at build time.
 * If unset, this module is a no-op.
 *
 * Wiring it up:
 *   1. Michael creates a Sentry project (separate from the backend project)
 *      at https://sentry.io.
 *   2. Copy the DSN.
 *   3. Add REACT_APP_SENTRY_DSN=<value> to /app/frontend/.env.production
 *      (and to the shell env when running `yarn build`).
 *   4. Rebuild + redeploy via /app/memory/DEPLOYMENT_RUNBOOK.md.
 *
 * Side notes:
 *   - `yarn add @sentry/react @sentry/tracing` first (deferred until DSN is
 *     ready to avoid adding 65 KB of unused bundle to the V1 launch).
 *   - sendDefaultPii: false — email/intake form data must not hit Sentry.
 */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  // Use webpackIgnore so webpack doesn't try to resolve @sentry/react at
  // build time (it's only installed once Michael wires the DSN).
  /* webpackIgnore: true */
  // eslint-disable-next-line no-eval
  const dynImport = (mod) => eval('import(mod)');
  dynImport('@sentry/react').then((Sentry) => {
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_KINDRA_ENV || 'production',
      release: process.env.REACT_APP_KINDRA_RELEASE || 'v1',
      sendDefaultPii: false,
      tracesSampleRate: 0.1,
    });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.warn('sentry: REACT_APP_SENTRY_DSN set but @sentry/react not installed — run `yarn add @sentry/react @sentry/tracing`');
  });
}
